let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jZQZD")).then(() => parcelRequire('dW522'));